import { CourierDtoCarrier, CourierDto, KnownCourierStatus } from '@groundfloor-platform/mgmt-service-g-sdk';

export class Courier {
  constructor(dto: CourierDto) {
    this.id = dto.id;
    this.firstName = dto.firstName;
    this.lastName = dto.lastName;
    this.status = dto.status as KnownCourierStatus;
    this.carrier = dto.carrier;
  }

  get canMakeDeliveries() {
    return this.status === KnownCourierStatus.Active || this.status === KnownCourierStatus.Pending;
  }

  id: string;
  firstName: string;
  lastName?: string;
  status: KnownCourierStatus;
  carrier: CourierDtoCarrier;
}
